import CityPage from "@/components/feature/CityPage";

const data = {
  cityName: "Andover",
  stateName: "Minnesota",
  stateAbbr: "MN",
  stateRoute: "/states/minnesota",
  heroImageQuery:
    "Aerial view of Andover Minnesota north metro suburb in Anoka County with spacious residential neighborhoods, large lot homes with mature trees, suburban commercial areas along Highway 10 and Crosstown Boulevard, rural to suburban transition landscape north of Minneapolis, clear blue sky daytime photography, professional aerial real estate photography, no readable signs or text",
  heroImageSeq: "andover-mn-hero-2026",
  heroDescription:
    "Caribbean cruise in six weeks and the kids' passports expired? Business trip to Europe with two weeks notice? Heritage visit abroad planned for summer? We help Andover residents — from Anoka County families and Ramsey area professionals to this growing north metro community — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other resellers. As fast as 24 hours. A+ BBB rated.",
  geoPosition: "45.2324; -93.3247",
  geoPlacename: "Andover, Minnesota",
  geoRegion: "US-MN",
  canonicalUrl: "https://fastpassportcenter.com/andover/",
  localAreaTitle: "Serving Andover & Northwest Anoka County",
  localAreaText: [
    "Andover, Minnesota is one of the fastest-growing communities in Anoka County, located in the northwest metro between Blaine and Ramsey. The city has developed rapidly as families seek large-lot, single-family homes in a quiet suburban setting with good schools. Andover High School is part of the Anoka-Hennepin School District, one of the largest and most respected in Minnesota.",
    "The city's location along Highway 10 and Highway 242 provides convenient access to the I-94 corridor, Twin Cities employment centers, and the Anoka County Airport (ANE) for general aviation. Many Andover residents commute to Minneapolis, Brooklyn Park, and Blaine for employment in technology, healthcare, retail, and professional services — industries that often require international travel.",
    "Andover's residential character — spacious lots, new construction, and family-oriented neighborhoods — attracts families who plan international vacations and educational travel. The city's outdoor recreation opportunities, including Bunker Hills Regional Park nearby, create an active community that embraces adventure travel, including international destinations.",
    "The northwest Anoka County community of Andover and its neighbors (Ramsey, Blaine, Ham Lake) form a growing regional hub where families plan everything from Caribbean cruises to European heritage trips. As the city continues to grow, its demand for expedited passport services increases accordingly.",
  ],
  nearbyCities: [
    { name: "Andover", zips: "55304" },
    { name: "Ramsey", zips: "55303" },
    { name: "Blaine", zips: "55014, 55449" },
    { name: "Ham Lake", zips: "55304" },
    { name: "Coon Rapids", zips: "55433, 55448" },
    { name: "Anoka", zips: "55303" },
  ],
  benefits: [
    {
      icon: "ri-computer-line",
      title: "Start 100% Online",
      desc: "No office visit required. Complete your order from your Andover home in minutes.",
    },
    {
      icon: "ri-truck-line",
      title: "Ship Your Documents",
      desc: "Overnight shipping from any UPS or FedEx location in the Andover area.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Expert Document Review",
      desc: "Every application reviewed before submission to catch errors that cause delays.",
    },
    {
      icon: "ri-calendar-check-line",
      title: "Reserved Agency Access",
      desc: "Reserved submission slots at the regional passport agency — no public appointment needed.",
    },
  ],
  serviceAreaTitle: "Andover & Northwest Anoka County",
  serviceAreaDescription: "Serving Anoka County and northwest metro communities with overnight courier",
  faqs: [
    {
      q: "How fast can I get a passport in Andover, MN?",
      a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility. Standard government processing through an Andover area post office can take 2–6 months — not suitable for upcoming trips.",
    },
    {
      q: "Can Andover families get passports before a Caribbean cruise?",
      a: "Absolutely. Andover families planning Caribbean cruises are among our most common north metro clients. We regularly process expedited family renewals and child passports with compressed timelines — as fast as 2–9 business days.",
    },
    {
      q: "Do I need to visit an office to use Fast Passport Center from Andover?",
      a: "No — most Andover travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Andover. You can ship from FedEx or UPS locations nearby in Andover, Blaine, or Coon Rapids.",
    },
    {
      q: "My family is planning a summer European trip. How early should we start passport renewals?",
      a: "We recommend starting at least 8 weeks before departure for standard expedited processing. If you are within 3 weeks of departure, you likely need our faster 2–9 business day option. Start as soon as you confirm travel plans.",
    },
    {
      q: "What if my child needs a first-time passport for a school trip?",
      a: "First-time minor passports require an in-person acceptance clerk visit with both parents (or one parent with consent documentation). We guide you through this step, then handle the expedited processing once documents are submitted.",
    },
    {
      q: "Are there passport acceptance facilities near Andover?",
      a: "The Andover Post Office, Ramsey Post Office, and Blaine Post Office all accept passport applications. We can guide you to the best option based on your schedule and situation.",
    },
  ],
  testimonials: [
    {
      name: "The Williams Family",
      location: "Andover, MN",
      rating: 5,
      text: "We had a Caribbean cruise booked from Miami and our two kids' passports had both expired. We had five weeks. Fast Passport Center processed both child passports in seven business days. We made our cruise and it was amazing. The team was very helpful in guiding us through the process. Highly recommend.",
      service: "Child Passport",
    },
    {
      name: "Brian K.",
      location: "Andover, MN",
      rating: 5,
      text: "I work in technology sales and received a trip to a European conference with three weeks notice. My passport had expired eight months earlier. Fast Passport Center processed my renewal in four business days. I presented at the conference and it was a great career moment. Professional and efficient service.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer S.",
      location: "Andover, MN",
      rating: 5,
      text: "Our family planned a European heritage trip to visit family in Norway. We discovered that my mother's passport was expiring within four months. Fast Passport Center processed her renewal in five business days. We traveled as a family and it was a trip we will remember forever. Thank you.",
      service: "Emergency Renewal",
    },
  ],
  nearbyLinks: [
    { name: "Blaine", href: "/cities/blaine" },
    { name: "Coon Rapids", href: "/cities/coon-rapids" },
    { name: "Ramsey", href: "/states/minnesota" },
    { name: "Brooklyn Park", href: "/cities/brooklyn-park" },
    { name: "Maple Grove", href: "/cities/maple-grove" },
    { name: "Minneapolis", href: "/cities/minneapolis" },
  ],
  introTitle: "Emergency & Expedited Passport Services in Andover",
  introDescription: "Fast passport processing for Andover and northwest Anoka County travelers.",
  localResourcesIntro:
    "Getting your passport ready involves more than just the application. Here are local Andover and northwest metro resources to help you gather everything you need before your next international trip.",
  acceptanceFacilities: [
    {
      name: "Andover Post Office",
      address: "14500 Andover Dr NW, Andover, MN 55304",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      phone: "(763) 427-2810",
      notes: "Primary passport acceptance facility for Andover residents. Appointment required. Call ahead for photo availability.",
    },
    {
      name: "Ramsey Post Office",
      address: "7550 Sunwood Dr NW, Ramsey, MN 55303",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(763) 427-8218",
      notes: "Serves Ramsey and northwest Anoka County. Good alternative for west Andover residents.",
    },
    {
      name: "Blaine Post Office",
      address: "10661 Club W Pkwy NE, Blaine, MN 55449",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(763) 786-9960",
      notes: "Convenient for south Andover and east Anoka County residents.",
    },
    {
      name: "Anoka Post Office",
      address: "2201 2nd Ave S, Anoka, MN 55303",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      phone: "(763) 421-1810",
      notes: "Anoka County seat. Full passport services. Photo services available.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Andover", address: "2095 Bunker Lake Blvd NW, Andover, MN 55304", hours: "Call for hours" },
    { name: "CVS Pharmacy — Blaine", address: "10740 University Ave NE, Blaine, MN 55434", hours: "Daily 7 AM – 10 PM" },
    { name: "Walgreens — Blaine", address: "11000 University Ave NE, Blaine, MN 55434", hours: "Call for hours" },
    { name: "CVS Pharmacy — Coon Rapids", address: "11900 Hanson Blvd NW, Coon Rapids, MN 55433", hours: "Daily 7 AM – 10 PM" },
    { name: "FedEx Office — Coon Rapids", address: "Coon Rapids commercial area", hours: "Call for hours" },
    { name: "The UPS Store — Blaine", address: "Blaine commercial area", hours: "Call for hours" },
  ],
  dmvLocations: [
    {
      name: "Anoka County Driver & Vehicle Services",
      address: "325 E Main St, Anoka, MN 55303",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Anoka County DVS. Driver licenses, REAL ID, titles & registration. Appointment recommended.",
      featured: true,
    },
    {
      name: "Anoka County Service Center — Blaine",
      address: "Blaine, MN area",
      hours: "Mon–Fri, 8:00 AM – 4:30 PM",
      note: "Satellite service center. Call ahead for available services.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "MSP",
      name: "Minneapolis-Saint Paul International Airport",
      distance: "About 30 miles from Andover — 30–35 minutes by car",
      address: "4300 Glumack Drive, St. Paul, MN 55111",
      note: "Primary international airport for Andover residents. Access via I-94 or Highway 10. Direct international flights to Europe, Asia, and Latin America.",
      flightUrl: "https://www.mspairport.com/",
      flightLabel: "MSP Airport Website",
      featured: true,
    },
    {
      code: "ANE",
      name: "Anoka County–Blaine Airport",
      distance: "About 10 miles from Andover",
      address: "707 Airport Rd, Blaine, MN 55449",
      note: "General aviation airport. Private and charter flights. FAA Air Traffic Control tower.",
      flightUrl: "https://www.co.anoka.mn.us/",
      flightLabel: "Anoka County Airport",
      featured: false,
    },
  ],
  travelCards: [
    {
      title: "North Metro Family Travel",
      subtitle: "Growing community of families planning international vacations",
      content:
        "Andover's family-oriented community plans international vacations regularly. Caribbean cruises, Mexico resort packages, and European heritage trips are popular choices. Families often book trips months in advance but discover passport issues when reviewing documents 4–6 weeks before departure.",
      tip: "Check every family member's passport at least 8 weeks before any international trip. Children's passports expire in 5 years — check annually.",
      icon: "ri-parent-line",
    },
    {
      title: "Anoka County Professional Travel",
      subtitle: "Technology and professional services workers with international assignments",
      content:
        "Andover and northwest Anoka County are home to many technology, healthcare, and professional services workers who commute to the metro area. These professionals receive international travel assignments with 2–4 weeks notice for conferences, client meetings, and project work.",
      tip: "Technology professionals should maintain passport validity at all times. International conference invitations are often time-sensitive.",
      icon: "ri-briefcase-4-line",
    },
    {
      title: "Scandinavian Heritage Travel",
      subtitle: "Norwegian, Swedish, and Danish heritage trips from the north metro",
      content:
        "Minnesota's north metro has a strong Scandinavian heritage, and many Andover families trace their roots to Norway, Sweden, and Denmark. Heritage trips to Scandinavia are increasingly popular as families seek to connect with their cultural roots. These trips are often planned 3–6 months in advance but passport issues arise last minute.",
      tip: "Heritage trips to Scandinavia are popular summer travel. Book passport renewals by March for summer departures.",
      icon: "ri-earth-line",
    },
    {
      title: "Outdoor Adventure Travel",
      subtitle: "Active families seeking adventure travel to international destinations",
      content:
        "Andover's outdoor recreation culture extends to international adventure travel. Families planning hiking in Costa Rica, skiing in the Alps, or wildlife viewing in Africa often discover passport issues close to departure. These trips are often booked through specialty travel agencies with specific departure dates.",
      tip: "Adventure travel dates are often fixed due to guide availability and permits. Start passport processing as soon as you book.",
      icon: "ri-map-2-line",
    },
  ],
  destinations: [
    {
      name: "Caribbean",
      context: "Cruises and all-inclusive resorts for Andover families, popular with north metro travelers",
      urgency: "Cruise departure dates are fixed — passport must be ready well in advance",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Mexico",
      context: "Cancun and Riviera Maya for Andover spring break and summer family travel",
      urgency: "Resort packages are often booked 3–4 weeks out — passport needs to be current",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Norway & Scandinavia",
      context: "Heritage travel for Andover's Scandinavian community",
      urgency: "Summer Scandinavian travel is planned months in advance but passport issues arise last minute",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Costa Rica",
      context: "Adventure travel popular with active Andover families",
      urgency: "Eco-tour bookings have fixed dates — start passport processing early",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "Germany",
      context: "Business travel and Oktoberfest travel from north metro professionals",
      urgency: "Business meetings and events have fixed schedules",
      icon: "ri-map-pin-2-line",
    },
    {
      name: "United Kingdom",
      context: "London for professional travel and family heritage trips",
      urgency: "Corporate travel often booked 2 weeks out — passport must be current",
      icon: "ri-map-pin-2-line",
    },
  ],
  stats: [
    { stat: "39%", label: "of Andover expedited requests are cruise or family vacation travel with fixed departure dates" },
    { stat: "4–6 Weeks", label: "most common advance notice window when Andover families discover passport issues" },
    { stat: "May–Aug", label: "peak travel season corresponding with school vacation and summer family travel" },
    { stat: "5–7 Days", label: "typical expedited processing time for Andover clients choosing our recommended option" },
  ],
};

export default function AndoverMNPage() {
  return <CityPage data={data} />;
}